import React, { useMemo } from 'react';
import 'Components/SbBubbleChart/customBubbleChart.scss';

const COLORS = [
    '#52BD94', '#FFB020', '#D14343', '#897AE3',
    '#25CBD6', '#ED55C2', '#DE7548', '#66460D',
    '#7D2828', '#524988', '#0F5156', '#8E3374',
    '#85462B', '#74DDE5', '#FAC86B', '#678AF7',
    '#6BDAAE', '#8F59EF', '#FD8ADC', '#70B0FF', '#FF9D66'
];

const BubbleChart = ({ skills = [] }) => {
    // Assign each unique skill label a color by its position in the array.
    // When skills > COLORS.length, colors cycle via modulo — no skill gets
    // silently stuck on index 0 the way the old useRef approach did.
    const colorMap = useMemo(
        () => Object.fromEntries(skills.map((s, i) => [s.label, COLORS[i % COLORS.length]])),
        [skills]
    );

    const occupied = {};
    const labelPositionMap = {};

    return (
        <div className="bubble-chart">
            {/* Axes and labels */}
            <div className="x-axis-line" />
            <div className="y-axis-line" />
            <div className="axis-label-x lo">Lo</div>
            <div className="axis-label-x hi">Hi</div>
            <div className="axis-label-y top">Required</div>
            <div className="axis-label-y bottom">Not Required</div>
            <div className="axis-title-x">IMPORTANCE OF SKILL*</div>
            <div className="axis-title-y">SKILLS REQUIRED*</div>

            {skills.map((skill, i) => {
                const gap = skill.requiredProficiency - skill.currentProficiency;
                const size = 20 + Math.abs(gap) * 6;

                let rawX = (skill.importance / 25) * 100;
                let rawY = 50 - (gap / 10) * 50;

                let x = rawX;
                let y = rawY;

                // Track collisions after rounding
                let key = `${Math.round(x)}|${Math.round(y)}`;
                while (occupied[key]) {
                    x += 2; // Shift to right
                    key = `${Math.round(x)}|${Math.round(y)}`;
                }
                occupied[key] = true;

                // Label logic based on original position
                const rawKey = `${Math.round(rawX)}|${Math.round(rawY)}`;
                labelPositionMap[rawKey] = (labelPositionMap[rawKey] || 0) + 1;
                const labelAbove = labelPositionMap[rawKey] % 2 === 0;

                return (
                    <div
                        key={i}
                        className="bubble"
                        style={{
                            left: `${x}%`,
                            top: `${y}%`,
                            width: `${size}px`,
                            height: `${size}px`,
                            backgroundColor: colorMap[skill.label],
                        }}
                    >
                        <div className="bubble-tooltip">
                            <strong>{skill.label}</strong><br />
                            Current: {skill.currentProficiency}<br />
                            Required: {skill.requiredProficiency}<br />
                            Gap: {gap}<br />
                            Importance: {skill.importance}
                        </div>
                    </div>
                );
            })}
        </div >
    );
};

export default BubbleChart;
